<template>
	<modal
		:active="active"
		:dismissable="false"
		title="Update required"
		@dismiss="dismiss"
	>

		<modal-body>
            <p>The portal has been updated and must be reloaded in order to continue.</p>
		</modal-body>

		<modal-actions>
			<btn primary @click="onReload">Reload</btn>
		</modal-actions>

	</modal>
</template>


<script>
    import { ModalMixin } from 'pdk/mixins';
    import { app } from '@/services';
    import { getters } from '@/store';


	export default {
        name: 'app-update-required-modal',
        mixins: [ModalMixin],
        props: {
            interval: {
                type: Number,
                default: 900000 // In milliseconds
            }
        },
		data() {
            return {
                checkerHandler: undefined
			};
        },
        computed: {
            updateRequired() {
                return this.$store.getters[getters.APP_UPDATE_REQUIRED];
            }
        },
        watch: {
            updateRequired: {
                immediate: true,
                handler(value) {
                    if (value === true) this.open();
                    if (value === false) this.close();

                    this.$emit('updaterequired', value);
                }
            }
        },
        created() {
            this.start();
        },
        beforeDestroy() {
            this.end();
        },
        methods: {
            start() {
                this.end();

                this.checkerHandler = setInterval(() => {
                    if (this.updateRequired === false) {
                        app.checkForUpdates();
                    }
                    else {
                        this.end();
                    }
                }, this.interval);

                this.$emit('start');
            },
            end() {
                if (this.checkerHandler) {
                    clearInterval(this.checkerHandler);
                    this.checkerHandler = undefined;
                    this.$emit('end');
                }
            },

            onReload() {
                this.$emit('reload');
                window.location.reload();
            }
		}
	};
</script>
